<div
  role="region"
  class="flex flex-col rounded-lg border border-slate-200 bg-white"
  data-testid="chart-card"
  [attr.aria-labelledby]="cardTitleId()"
>
  <!-- Header -->
  <div
    class="flex items-center justify-between border-b border-slate-100 px-4 py-3"
  >
    <div class="flex flex-col gap-0.5">
      <h3 [id]="cardTitleId()" class="text-sm font-semibold text-slate-900">
        {{ title() }}
      </h3>
      @if (subtitle()) {
        <p class="text-xs text-slate-500">{{ subtitle() }}</p>
      }
    </div>

    <div class="flex items-center gap-2">
      @if (showCacheChip()) {
        <span
          data-testid="cache-hit-chip"
          class="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-500"
        >
          <mat-icon class="!h-3 !w-3 !text-xs">cached</mat-icon>
          {{ formattedFetchedAt() }}
        </span>
      }
    </div>
  </div>

  <!-- Body -->
  <div class="relative min-h-[200px] p-4">
    @if (loading()) {
      <!-- Loading skeleton overlay -->
      <div
        data-testid="chart-card-loading"
        aria-live="polite"
        aria-label="Loading chart data"
        class="absolute inset-0 z-10 flex items-center justify-center rounded-b-lg bg-white/80"
      >
        <div class="flex flex-col items-center gap-3">
          <div
            class="h-32 w-full max-w-xs animate-pulse rounded bg-slate-100"
          ></div>
          <div class="h-3 w-24 animate-pulse rounded bg-slate-100"></div>
        </div>
      </div>
    } @else if (errorMessage()) {
      <!-- Error overlay -->
      <div
        data-testid="chart-card-error"
        aria-live="assertive"
        role="alert"
        class="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 rounded-b-lg bg-white/90"
      >
        <mat-icon class="!h-8 !w-8 !text-3xl text-slate-300"
          >error_outline</mat-icon
        >
        <p class="max-w-xs text-center text-sm text-slate-500">
          {{ errorMessage() }}
        </p>
        @if (retryable()) {
          <button
            mat-stroked-button
            type="button"
            class="!h-8 !text-xs"
            data-testid="chart-card-retry"
            [attr.aria-label]="'Retry loading ' + title()"
            (click)="retry.emit()"
          >
            Retry
          </button>
        }
      </div>
    } @else if (empty()) {
      <!-- Empty state overlay -->
      <div
        data-testid="chart-card-empty"
        aria-live="polite"
        tabindex="0"
        class="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 rounded-b-lg bg-white/90"
      >
        <mat-icon class="!h-8 !w-8 !text-3xl text-slate-300">{{
          emptyIcon()
        }}</mat-icon>
        <p class="text-sm text-slate-400">{{ emptyText() }}</p>
      </div>
    }

    <!-- Chart content slot -->
    <ng-content />
  </div>
</div>
